"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVATAR_SEASON_LIST = exports.PORTRAIT_RATIO = void 0;
exports.getSeasonAvatarPath = getSeasonAvatarPath;
exports.getSeasonAvatarItemType = getSeasonAvatarItemType;
exports.findSeasonAvatar = findSeasonAvatar;
const career_1 = require("./career");
/** Display height multiplier for portrait avatars (2:3 ratio) */
exports.PORTRAIT_RATIO = 1.5;
/**
 * Avatars saisonniers — universels (aucune restriction de race).
 * Pour ajouter des avatars : déposer l'image dans
 *   client/public/tile/shop/avatar-season/s{season}/
 * et ajouter une entrée ici.
 */
exports.AVATAR_SEASON_LIST = [
    { file: "1.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "2.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "3.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "4.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "5.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "6.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "7.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "8.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "9.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "10.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "11.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "12.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "13.png", season: 17, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "1.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "2.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "3.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "4.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "5.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "6.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "7.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "8.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "9.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "10.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "11.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "12.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "13.png", season: 19, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    // Saison 20 — ajouter une ligne par fichier déposé dans
    // client/public/tile/shop/avatar-season/s20/. Ne déclarer que les fichiers
    // réellement présents : une entrée sans image affiche un visuel cassé en
    // boutique et laisse acheter un avatar inexistant.
    { file: "1.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "2.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "3.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "4.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "5.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "6.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "7.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "8.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "9.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "10.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "11.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "12.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
    { file: "13.png", season: 20, rarity: career_1.AVATAR_RARITY.SEASONAL, portrait: true },
];
/** Chemin complet utilisé pour afficher l'avatar d'un joueur (ex: <img src>) */
function getSeasonAvatarPath(season) {
    return `tile/shop/avatar-season/s${season}`;
}
/** Chemin relatif utilisé comme prop `type` dans le composant Item du shop */
function getSeasonAvatarItemType(season) {
    return `avatar-season/s${season}`;
}
function findSeasonAvatar(file) {
    return exports.AVATAR_SEASON_LIST.find((a) => a.file === file);
}
